export const generateDefaultOptions = (): uui.domain.ui.list.ListOptions => {
  return {
    search: {
      query: '',
      fields: ['name'],
      operator: 'or',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'name',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
